import {initUpload} from '../../../../src/common/scripts/common';

export default function(form, selector) {
    const fileFields = [...selector.querySelectorAll('.j-form-file')];

    form.init({
        target        : selector,
        successMessage: true
    });

    form.createInput({
        target: selector.querySelector('.j-input-agreement'),
        mode  : 'agreement',
        error : 'Для продолжения необходимо согласие'
    });

    fileFields.forEach((field) => {
        form.createInput({
            target: field,
            mode  : 'file',
            error : 'Загрузите файл'
        });

        const upload = field.closest('.j-upload');

        initUpload(upload);
    });
}
